// extracted by mini-css-extract-plugin
module.exports = {"iconImage":"about_iconImage__3TrVi","facilityCard":"about_facilityCard__2qhJO","marker":"about_marker__GwKyO","label":"about_label__1llnI"};